import { useIdentity } from 'app/core/api/company/api-company';
import Button from 'app/shared/components/button/Button';
import Body from 'app/shared/components/typography/body/Body';
import SharedRoutePath from 'app/shared/SharedRoutePath';
import styledFuncs from 'app/styles/styledFuncs';
import { Redirect } from 'react-router-dom';
import { css } from 'styled-components/macro';
import BusinessRoutePath from '../BusinessRoutePath';

export default function NewUserIntro(): JSX.Element {
  const { resource: { company } = {} } = useIdentity();
  if (company) return <Redirect to={SharedRoutePath.HOME} />;
  return (
    <>
      <div
        css={css`
          padding: ${styledFuncs.pad()};
          > p:not(:last-child) {
            padding-bottom: ${styledFuncs.pad(2)};
          }
        `}
      >
        <Body>Welcome to iWarranty - your green repair network!</Body>
        <Body>
          Soon you’ll be able to connect with customers straight
          through the app.
        </Body>
        <Body>
          First things first - create your profile so customers can
          find you.
        </Body>
      </div>
      <Button to={BusinessRoutePath.SELECT_BUSINESS_TYPE}>
        Create Profile
      </Button>
    </>
  );
}
